import React from 'react'
import {ISelectInput} from "./interfaces";
import {FormControl, IconButton, MenuItem, Select} from '@mui/material'
import {SelectInputActionContainer, SelectInputFullWidth, SelectInputLabel, SelectInputRoot} from "./styles";
import {ArrowDropDown, ArrowDropUp} from '@mui/icons-material';

const defaultData = [
    {
        value: 'all',
        label: 'All'
    },
    {
        value: 'Ten',
        label: 'Ten'
    },
    {
        value: 'Twenty',
        label: 'Twenty'
    },
    {
        value: 'Thirty',
        label: 'Thirty'
    },
]

/**
 * Render a drop-down select menu
 * @param name
 * @param label
 * @param id
 * @param selectData
 * @param value
 * @param onChange
 * @param onNextClick
 * @param onPrevClick
 * @param hasAction
 * @param shrinkLabel
 * @param activeState
 * @param handleToggle
 * @constructor
 */
const SelectInput = ({
    name = '',
    label = 'Location',
    id = 'location',
    selectData = defaultData,
    value = 'all',
    onChange,
    onNextClick,
    onPrevClick,
    hasAction = true,
    shrinkLabel,
    activeState,
    handleToggle
}: ISelectInput) => {
  return (
    <SelectInputRoot item>
      <SelectInputFullWidth item>
        <FormControl variant='standard' fullWidth>
          <SelectInputLabel id={id} shrink={shrinkLabel}>
            {label}
          </SelectInputLabel>
          <Select
            name={name}
            labelId={id}
            value={value}
            onChange={onChange}
            displayEmpty
            fullWidth
          >
            {selectData.map((item, index) => (
              <MenuItem key={index} value={item.value} disabled={item.disabled}>{item.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </SelectInputFullWidth>
      {
        hasAction && <SelectInputActionContainer onClick={handleToggle}>
          <IconButton
            onClick={onNextClick}
            sx={{
              width: '100%',
              height: '0.5em',
              p: '0.2em',
              color: activeState ? 'primary.contrastText' : 'grey.400'
            }}>
            <ArrowDropUp fontSize='large'/>
          </IconButton>
          <IconButton
            onClick={onPrevClick}
            sx={{
              width: '100%',
              height: '0.5em',
              p: '0.2em',
              color: !activeState ? 'primary.contrastText' : 'grey.400'
            }}>
            <ArrowDropDown fontSize='large'/>
          </IconButton>
        </SelectInputActionContainer>
      }
    </SelectInputRoot>
  )
}

export default SelectInput
